const PREFIX = 'web.admin.inspections.templateCustomize.v2';

export const LABEL_KEYS = {
  breadcrumbLibrary: `${PREFIX}.breadcrumbLibrary`,
  breadcrumbEditTemplate: `${PREFIX}.breadcrumbEditTemplate`,
  lastUpdated: `${PREFIX}.lastUpdated`,
  templateSummary: `${PREFIX}.templateSummary`,
  noSections: `${PREFIX}.noSections`,
  noQuestions: `${PREFIX}.noQuestions`,
  sectionCountsInherited: `${PREFIX}.sectionCountsInherited`,
  sectionCountsLocal: `${PREFIX}.sectionCountsLocal`,
  lockQuestionTooltip: `${PREFIX}.lockQuestionTooltip`,
  lockSectionTooltip: `${PREFIX}.lockSectionTooltip`,
  hiddenQuestionTooltip: `${PREFIX}.hiddenQuestionTooltip`,
} as const;

export type LabelKey = (typeof LABEL_KEYS)[keyof typeof LABEL_KEYS];

export type Message = {
  key: LabelKey;
  params?: Record<string, string | number>;
};

export type BadgeViewModel = {
  kind: 'lock' | 'hidden';
  tooltipKey: LabelKey;
};
